import {useEffect} from "react";

export function OpenCommentsTabContainer({imageViewer, data, selection, children}) {
    useEffect(() => {
        const found = data.find(el => selection.commentSelected(el));
        imageViewer.commentSourceSelected$.next({target: found});
    }, [data, selection, imageViewer]);

    return children();
}